import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOffers,
  getcouponOffers,
} from "../../features/feature1/feature1Slice";
import Spinner from "react-bootstrap/Spinner"; // Import the Spinner component

const Offer = () => {
  const dispatch = useDispatch();
  const {
    offers = [],
    couponOffers = {},
    status,
    error,
  } = useSelector((state) => state.feature1);

  const [selectedCouponCode, setSelectedCouponCode] = useState("");

  useEffect(() => {
    dispatch(getOffers());
  }, [dispatch]);

  useEffect(() => {
    if (offers.length > 0 && !selectedCouponCode) {
      setSelectedCouponCode(offers[0].coupon_code);
    }
  }, [offers, selectedCouponCode]);

  useEffect(() => {
    if (selectedCouponCode) {
      dispatch(getcouponOffers({ coupon_code: selectedCouponCode }));
    }
  }, [selectedCouponCode, dispatch]);

  const handleCouponSelect = (couponCode) => {
    setSelectedCouponCode(couponCode);
  };

  if (status === "loading") {
    return (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (status === "failed") {
    return <p>Error: {error}</p>;
  }

  return (
    <>
      <div className="main-banner">
        <div className="container my-5">
          <h2>Offers</h2>
          <div className="serach-box-data">
            <div className="row justify-content-center mx-0 ">
              <div className="col-sm-6">
                {offers.length > 0 ? (
                  offers.map((offer) => (
                    <div
                      className="text-center py-3"
                      key={offer._id}
                      onClick={() => handleCouponSelect(offer.coupon_code)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={offer.offerBanner}
                        alt={offer.title}
                        className="img-fluid"
                      />
                      <div className="offer-title">
                        <h4>{offer.title}</h4>
                        <p>Valid Until: {offer.validateTo}</p>
                        <p>Coupon Code: {offer.coupon_code}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No offers available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="main-banner">
        <div className="container my-5">
          <h2>Selected Coupon Offer</h2>
          <div className="serach-box-data">
            <div className="row justify-content-center mx-0 ">
              <div className="col-sm-6">
                {couponOffers && couponOffers._id ? (
                  <div className="text-center py-3" key={couponOffers._id}>
                    <img
                      src={couponOffers.offerBanner}
                      alt={couponOffers.title}
                      className="img-fluid"
                    />
                    <div className="offer-title">
                      <h4>{couponOffers.title}</h4>
                      <p>{couponOffers.description}</p>
                      <p>
                        Valid Until:{" "}
                        {new Date(couponOffers.validateTo).toLocaleDateString()}
                      </p>
                      <p>
                        Discount: {couponOffers.discount}{" "}
                        {couponOffers.discount_type === "perc" ? "%" : ""}
                      </p>
                      <p>Coupon Code: {couponOffers.coupon_code}</p>
                    </div>
                  </div>
                ) : (
                  <p>No coupon offer selected</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Offer;
